<template>
  <div class="margin-bottom-100">
    <div class="paygrpsDiv">
      <div class="alignPaygrp">
        <span>Selected Employees</span>
        <br />
        <div class="paygrps-info">
          <b>{{ offPayrollSelectedEmployees }}</b>
        </div>
      </div>
      <div class="alignPaygrp">
        <span>TDS Overrides</span>
        <br />
        <div class="paygrps-info">
          <b>{{ offPayrollTdsOverrides }}</b>
        </div>
      </div>
    </div>
    <div class="d-payroll__group">
      <div class="d-heading2 d-marginBottom d-flexbox">TDS Overrides</div>
    </div>

    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <!-- <button v-if="showTag" class="rect">
      <span>{{ tagEmpName }}</span>
      <img src="@/assets/group-6.svg" @click="closeTag" />
    </button> -->

    <div class="tdsClass">
      <tl-select
        placeholder="Select"
        name="tdsOverRides"
        label
        labelText="name"
        :options="tdsOptions"
        v-model="formData.tds_overrideObj"
        @change="(val)=>changeTds(val)"
        v-validate="{required: true}"
        data-vv-as="TDS Overrides"
        :classname="errors.has('tdsOverRides')"
        :errormsg="errors.first('tdsOverRides')"
      />
    </div>

    <div v-if="tdsType">
      <div class="margin-top-30">
        <div class="computeClass">
          <tl-radio
            label="Bulk Upload"
            name="uploadMethod"
            id="bulkUpload"
            value="bulkUpload"
            @change="(val)=>computeType(val)"
            v-model="uploadMethod"
          />
          <tl-radio
            label="Manual"
            name="uploadMethod"
            id="manualUpload"
            value="manualUpload"
            v-model="uploadMethod"
            @change="(val)=>computeType(val)"
          />
        </div>
        <div v-if="uploadMethod == 'bulkUpload'">
          <div class="download-btn">
            <download-button
            onclick="location.href='https://dev-opn-test1.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/OverrideMonthlyTDS.xls'"
            ></download-button>
          </div>
          <div class="margintop-20">
            <!-- <upload-file :apiUrl="bulkUploadUrl" @uploadTemplate="onUploadTemplate($event)" /> -->
            <upload :tobucket="false" ref="bulkFile" @change="onUploadTemplate($event)"></upload>
          </div>
        </div>
        <div v-if="uploadMethod == 'manualUpload'">
          <div class="margin-top-30">
            <div class="singleColumnGrid">
              <div>
                <tl-select
                label="Select Employee"
                placeholder="Select"
                labelText="empCode"
                :value="employee"
                :options="employeeData"
                @change="(val) => { employee = val.empCode; setEmployee(val) }"
                />
              </div>
              
              <txt
                autofocus="autofocus"
                name="taxAmount"
                label="Tax Amount *"
                type="number"
                v-numeric-only
                v-model="formData.tds_override_value"
                data-vv-as="Tax Amount"
                v-validate="{required: true, max: 9}"
                :classname="errors.has('taxAmount')"
                :errormsg="errors.first('taxAmount')"
              />

              <br />
            </div>
            <btn text="Add" type="secondary" v-on:click="add"></btn>
          </div>
        </div>
      </div>
    </div>
    <div class="lock-list">
      <tl-checkbox label="Lock TDS Overrides" @change="(bool)=>{locklist(bool)}"></tl-checkbox>
    </div>

    <pop-up-message
      v-if="showSuccessMsg"
      :message="popupMsg"
      btnText="Back"
      @back="backfrompopup()"
    />

    <footer>
      <bottom-action-container>
        <btn-skip @navClicked="skip" />
        <template slot="end">
          <btn-grp class="form-button">
            <btn text="Cancel" type="secondary" @click="cancel" />
            <btn text="Next" :disabled="!isLocked" type="primary" @click="save" />
          </btn-grp>
        </template>
      </bottom-action-container>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
//import SearchDropdown from "@/components/TlSearchDropdown.vue";
//import selectedEmployeeCard from "@/components/dashboard/selectedEmployeeCard.vue";
import * as constants from "@/apis/constants.js";
import { api_variables } from "@/apis/variables.js";

export default {
  name: "Tds",
  // components: {
  //   SearchDropdown, selectedEmployeeCard
  // },
  data() {
    return {
      errmsg: "",
      toast: false,

      showSuccessMsg: false,
      popupMsg: "",
      formData: {
        tds_overrideObj: null,
        employeeObj: null,
        tds_override_value: null
      },

      countObj: {
        payGroupsSelected: 0,
        totalEmployeesSelected: 0,
        eligibleEmployeesSelected: 0,

        totalPayGroups: 0,
        totalEmployees: 0,
        totalEligibleEmployees: 0
      },

      searchText: "",
      tdsType: "Compute For This Month",
      tdsOptions: [],
      month: "May",
      uploadMethod: "manualUpload",
      tagEmpName: "",
      empId: "",
      showTag: false,
      employeeData: [],
      isLocked: false,
      showEmpDetails: false,
      bulkUploadUrl: api_variables.SERVICE_TDS_BULK_UPLOAD,
      offPayrollSelectedEmployees: 0,
      offPayrollTdsOverrides: 0,
    };
  },
  activated() {
    this.uploadMethod = "manualUpload";
    this.$validator.reset();
    this.setConstantsData();
    this.refresh();
    this.setData();
      if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeData = this.selectedEmployeesList[0].employees
    }
    this.fetchOffPayrollSummaryData();
  },
  mounted() {
    this.setConstantsData();
      if(this.le_id == this.selectedEmployeesList[0].le_id){
        this.employeeData = this.selectedEmployeesList[0].employees
    }
    this.fetchOffPayrollSummaryData();
  },
  beforeDestroy() {
    this.refresh();
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    ...mapState({
      selectedPayGroupsData: state => state.payroll.paygroups.data,
      payGroupsData: state => state.payroll.paygroups.payGroups,
      payrollMonth: state => state.payroll.runpayroll.payrollMonth,
      payrollYear: state => state.payroll.runpayroll.payrollYear
    }),
    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState({
        selectedEmployeesList: state => state.payroll.selectedemployee.employeeDataForOffCycle,
    }),
  },
  methods: {
    ...mapActions({
      act_create: "payroll/tds/create",
      fetchEmployeeByName: "globalapi/globalemployees/fetchByName",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName",
      act_upload: "payroll/tds/act_upload",
      act_get_off_payroll_summary: "payroll/selectedemployee/createSummaryData"
    }),
    /** To set the drop down options from constants file */
    setConstantsData() {
      try {
        this.tdsOptions = constants.TdsConstants.tdsList;
        this.formData.tds_overrideObj = this.tdsOptions.length
          ? this.tdsOptions[3]
          : null;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },
    /** Navigation */
    skip() {
      this.refresh();
      this.$router.push({
        path: `/payroll/run/${this.$route.params.entity_index}/summaryForOffPayroll`
      });
    },
    /** Function to search the employee by LE id and Employee name */
    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val
        });
        this.employeeData = res.data.payload;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** Function to set the counts of different elements in UI */
    setData() {
      try {
        let payGroupsData = this.payGroupsData[this.le_id];
        let selectedPayGroupsData = this.selectedPayGroupsData[this.le_id];

        if (payGroupsData) {
          this.countObj.totalPayGroups = payGroupsData.length;

          let totalEmployees = 0;
          let totalEligibleEmployees = 0;

          payGroupsData.forEach(item => {
            totalEmployees =
              totalEmployees + (item.totalEmployess ? item.totalEmployess : 0);
            totalEligibleEmployees =
              totalEligibleEmployees +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });

          this.countObj.totalEmployees = totalEmployees;
          this.countObj.totalEligibleEmployees = totalEligibleEmployees;
        }

        if (selectedPayGroupsData) {
          this.countObj.payGroupsSelected = selectedPayGroupsData.length;

          let totalEmployeesSelected = 0;
          let eligibleEmployeesSelected = 0;

          selectedPayGroupsData.forEach(item => {
            totalEmployeesSelected =
              totalEmployeesSelected +
              (item.totalEmployess ? item.totalEmployess : 0);
            eligibleEmployeesSelected =
              eligibleEmployeesSelected +
              (item.eligibleEmployees ? item.eligibleEmployees : 0);
          });

          this.countObj.totalEmployeesSelected = totalEmployeesSelected;
          this.countObj.eligibleEmployeesSelected = eligibleEmployeesSelected;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    async fetchOffPayrollSummaryData() {
      try {
        let employeeIds = []
        this.employeeData.map(element => {
          employeeIds.push(element.empId);
        })
        let data = {
          le_id: this.le_id,
          processing_payroll_month: this.getSelectedMonthEnumByName(
            this.payrollMonth
          ),
          financial_year: this.payrollYear,
          employeeIds:  employeeIds
        };
        let res = await this.act_get_off_payroll_summary({data});
        if (res.data.status) {
          this.offPayrollSelectedEmployees = res.data.payload.totalHeadCount;
          this.offPayrollTdsOverrides= res.data.payload.tdsOverridenAmount;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
      /** Function  to reset the form data*/
    refresh() {
      try {
        this.month = "";

        this.formData = {
          tds_overrideObj: { name: "Compute For This Month", id: "FIXED" },
          employeeObj: null,
          tds_override_value: null
        };
        //this.showTag = false;
        this.showEmpDetails = false;
        this.searchText = "";
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    addTds() {
      this.add();
    },
    /** Function to validate the form data */
    async add() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction("add");
        }
      });
    },
    /** Function to submit the form data to server */
    async performAction(type) {
      try {
        if (!this.isLocked) {
          if (!this.formData.employeeObj) {
            this.toast = true;
            this.errmsg = "Please select employee";
            return;
          } else if (!this.formData.employeeObj.empId) {
            this.toast = true;
            this.errmsg = "Please select employee";
            return;
          } else {
            this.toast = false;
            this.errmsg = "";
          }

          var mm = this.payrollMonth;
          var yyyy = this.payrollYear;
          let selectedMonthEnum = this.getSelectedMonthEnum(mm);

          let obj = {
            data: {
              employee_id: this.formData.employeeObj
                ? this.formData.employeeObj.empId
                : null,
              year: yyyy,
              tds_override_value: this.formData.tds_override_value,
              month: selectedMonthEnum,
              tds_override: this.formData.tds_overrideObj.id
            }
          };

          try {
            this.$root._data.isSaving = true;
            let res = await this.act_create(obj);
            setTimeout(() => {
              if (res.status == 200 || res.status == 201) {
                if (type == "next") {
                    this.$router.push({
                    path: `/payroll/run/${this.$route.params.entity_index}/summaryForOffPayroll`,
                  });
                } else {
                  this.showSuccessMsg = true;
                  this.popupMsg = res.data.message;
                }

                this.refresh();
              }
              this.$root._data.isSaving = false;
            }, 500);
          } catch (err) {
            this.$root._data.isSaving = false;
            this.toast = true;
            this.errmsg = err;
          }
        } else {
          this.$router.push({
            path: `/payroll/run/${this.$route.params.entity_index}/summaryForOffPayroll`,
          });
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    backfrompopup() {
      this.showSuccessMsg = false;
      this.fetchOffPayrollSummaryData();
    },
    /** Function to get the selected month enum by Name*/
    getSelectedMonthEnum(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec";
            break;

          default:
            break;
        }
        return selectedMonthEnum;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To lock/unlock the 'Next' button */
    locklist(ee) {
      if (ee) {
        this.isLocked = true;
      } else {
        this.isLocked = false;
      }
    },
    /** On click of TDS type drop down */
    changeTds(val) {
      try {
        if (val) {
          this.tdsType = val.name;
          this.formData.tds_overrideObj = val;
        } else {
          this.tdsType = "";
          this.formData.tds_overrideObj = null;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To change the screen type */
    computeType(val) {
      this.uploadMethod = val;
    },
    /** On click of selected employee in search bar */
    selectedEmp(emp) {
      try {
        this.showEmpDetails = true;
        if (emp) {
          this.formData.employeeObj = emp;
        }
        this.empId = emp.code;
        this.tagEmpName = `${emp.first_name}`;
        //this.showTag = true;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    setEmployee(emp){
      try {
        this.showEmpDetails = true;
        if (emp) {
          this.formData.employeeObj = emp;
        }
        this.empId = emp.code;
        this.tagEmpName = `${emp.first_name}`;
        //this.showTag = true;
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    /** To clear the seleted employee data */
    close() {
      //this.showTag = false;
      this.showEmpDetails = false;
      this.formData.employeeObj = null;
      this.searchText = null;
    },
    /** Naviation to previous screens */
    cancel() {
        this.$router.push({
          path: `/payroll/run/${this.$route.params.entity_index}/variableEarningsForOffPayroll`,
        });
    },
    save() {
      this.performAction("next");
    },

    /***** BULK UPLOAD Previous implementation *****/
    
    async onUploadTemplate(event) {
      let fy = this.payrollYear;
      let mm = this.getSelectedMonthEnumByName(
            this.payrollMonth
          );
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);
      formData.append("processing_month", mm)
      formData.append("financial_year", fy);

      try {
        let res = await this.act_upload(formData);
        if (res.status == 200 || res.status == 201) {
          this.popupMessage = res.data.message ? res.data.message : "";
          this.$refs.bulkFile.uploaded = true;
          this.$refs.bulkFile.uploading = false;
          this.showBulkUploadSuccessMsg = true;
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },
    
    /** Function to return the selected month enum */
    // Add function here By Bhushan Date: 12 Aug 2021
    getSelectedMonthEnumByName(selectedMonth) {
      try {
        let selectedMonthEnum = "";
        switch (selectedMonth) {
          case "January":
            selectedMonthEnum = "jan";
            break;
          case "February":
            selectedMonthEnum = "feb";
            break;
          case "March":
            selectedMonthEnum = "mar";
            break;
          case "April":
            selectedMonthEnum = "apr";
            break;
          case "May":
            selectedMonthEnum = "may";
            break;
          case "June":
            selectedMonthEnum = "jun";
            break;
          case "July":
            selectedMonthEnum = "jul";
            break;
          case "August":
            selectedMonthEnum = "aug";
            break;
          case "September":
            selectedMonthEnum = "sep";
            break;
          case "October":
            selectedMonthEnum = "oct";
            break;
          case "November":
            selectedMonthEnum = "nov";
            break;
          case "December":
            selectedMonthEnum = "dec"; // PL-2264
            break;

          default:
            break;
        }
        return selectedMonthEnum; // Enum type - values :  ['jan', 'feb','mar', 'apr','may', 'jun','jul', 'aug','sep', 'oct','nov', 'dec']
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

   /***** BULK UPLOAD Current implementation *****/
    // async onUploadTemplate(res) {
    //   try {
    //     if (res.data && res.data.status) {
    //       this.popupMessage = res.data.message ? res.data.message : "";
    //       this.showBulkUploadSuccessMsg = true;
    //     } else {
    //       this.toast = true;
    //       this.errmsg = res.message;
    //     }
    //   } catch (err) {
    //     this.$root._data.isSaving = false;
    //     this.toast = true;
    //     this.errmsg = err;
    //   }
    // },

  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section

.margin-bottom-100 {
  margin-bottom: 100px;
}

.paygrpsDiv {
  display: flex;
  cursor: pointer;
  padding: 40px 0px;

  span {
    color: #646464;
    font-size: 16px;
  }
  > :nth-child(n) {
    margin-right: 64px;
  }
  > :last-child {
    margin-right: 0px;
  }
}
.tdsClass {
  width: 23%;
  margin-top: 2%;
}
.paygrps-info {
  color: #646464;
  cursor: pointer;
  text-align: center;
  margin-top: 5px;

  b {
    font-size: 24px;
    font-weight: 500;
  }
}
.computeClass {
  display: flex;
}
.paygrp {
  background: #fbfbfb;
  width: 31%;
  height: 85px;
  border-radius: 2px;
  border: solid 1px #37c6c0;
  padding: 20px;
  text-align: center;
  display: flex;
  justify-content: inherit;
}
.rect {
  width: 150px;
  min-width: auto;
  margin-left: 1%;
  margin-top: 1%;
  height: 30px;
  border-radius: 15px;
  background-color: #c7efef;
  text-align: center;
  cursor: pointer;
}
.alignPaygrp {
  padding: 20px;
  text-align: center;
}
.d-marginBottom {
  margin-bottom: 7px;
}
.line {
  border-bottom: 1px solid #c8c8c8;
  width: 100%;
  margin-bottom: 20px;
}
.label {
  font-size: 12px;
  font-weight: 300;
  margin-bottom: 8px;
  color: #6e6e6e;
}
.download-btn {
  margin-top: 2%;
}
.lock-list {
  margin-top: 2%;
  display: flex;
  span {
    margin-top: 2px;
  }
}
.margin-top-30 {
  margin-top: 30px;
}
</style>
